export default function TrustBar() {
  return (
    <section className="bg-gradient-to-br from-orange-50 via-white to-red-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Asymmetrical Grid Layout */}
        <div className="grid grid-cols-2 lg:grid-cols-12 gap-4">
          {/* Large Featured Card - Reviews */}
          <div className="col-span-2 lg:col-span-5 bg-white rounded-2xl p-8 shadow-lg border-2 border-orange-100 hover:shadow-xl transition-all duration-300">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center">
                <i className="ri-star-fill text-3xl text-white"></i>
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className={`ri-star-${i < 4 ? 'fill' : 'half-fill'} text-yellow-400 text-xl`}></i>
                  ))}
                </div>
                <div className="text-4xl font-bold text-slate-900 mb-1">4.6 Rating</div>
                <div className="text-slate-600 font-medium">Based on 10 verified Google reviews</div>
              </div>
            </div>
          </div>

          {/* Medium Card - Experience */}
          <div className="col-span-1 lg:col-span-3 bg-white rounded-2xl p-6 shadow-md border border-orange-50 hover:shadow-lg transition-all duration-300">
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-time-line text-2xl text-orange-600"></i>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1">20+ Years</div>
            <div className="text-sm text-slate-600">Serving Southern California</div>
          </div>

          {/* Medium Card - Licensed */}
          <div className="col-span-1 lg:col-span-4 bg-gradient-to-br from-orange-500 to-red-500 rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-fill text-2xl text-white"></i>
              </div>
              <div className="text-2xl font-bold text-white">Licensed & Insured</div>
            </div>
            <div className="text-white/90 text-sm">Fully certified and protected for your peace of mind</div>
          </div>

          {/* Small Cards Row */}
          <div className="col-span-2 lg:col-span-12 grid grid-cols-2 md:grid-cols-3 gap-4">
            <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:border-orange-200 transition-all duration-300">
              <div className="text-2xl font-bold text-orange-600 mb-1">5000+</div>
              <div className="text-xs text-slate-600">Successful Moves</div>
            </div>
            <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:border-orange-200 transition-all duration-300">
              <div className="text-2xl font-bold text-orange-600 mb-1">Same Day</div>
              <div className="text-xs text-slate-600">Service Available</div>
            </div>
            <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:border-orange-200 transition-all duration-300">
              <div className="text-2xl font-bold text-orange-600 mb-1">Free</div>
              <div className="text-xs text-slate-600">No-Obligation Quotes</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}